import schedulesViewStateStore from "../store/store";
import { mutatorAction } from "satcheljs";

export default mutatorAction('SET_SHOW_CONFLICTS_FROM_USER_SETTINGS', function setShowConflictsFromUserSetting(showConflicts: boolean) {
    schedulesViewStateStore().showShiftConflicts = showConflicts;
});
